/**
 * Preview JavaScript singleton module
 */

var Preview = (function($) {

  function initPreview() {
       
  }

  function init() {

        // return early if no corresponding module present
    if (!$('#column-preview').length) {
      return;
    }

    var preview = $("#column-preview");
    var previewDefault =  $("#column-preview").attr("data-background");

    $(".column__item").addClass("column__item--loaded");

    $(".column__item--loaded").not('.column__item--disabled, .column__item--active').hover(function () {
        var backgroundImage = $(this).find('.column__link').attr("data-image");
        preview.css("background-image","url(" + backgroundImage + ")");
        $('#post-content').hide();

    }, function () {
        //preview.css("background-image","url(" + previewDefault + ")");
        $('#post-content').show();
        preview.css("background-image","none");
        if ($('.home').length) {
          //preview.css("background-image","url(" + previewDefault + ")");
        } else {
          preview.css("background-image","none");

        }
    });

    if ($('.single-post').length) {
      $('#post-content').show();
      preview.css("background-image","none");
    }

    initPreview();

    $('#print-button').click(function(e){
      e.preventDefault();
      window.print();
      return false;
  });

  }

  return {
    init: init
  };

}(jQuery));

jQuery(document).ready(Preview.init);
